const isEmpty = value => value == null || value === '';

export default isEmpty;
